import { render, staticRenderFns } from "./ProjectProgressUpdateDelegation.vue?vue&type=template&id=6f3b4dce&scoped=true&"
import script from "./ProjectProgressUpdateDelegation.vue?vue&type=script&lang=js&"
export * from "./ProjectProgressUpdateDelegation.vue?vue&type=script&lang=js&"
import style0 from "./ProjectProgressUpdateDelegation.vue?vue&type=style&index=0&id=6f3b4dce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3b4dce",
  null
  
)

export default component.exports